var map = {
	"./1.jpg": "4b35",
	"./card-user-review.png": "f66e",
	"./carousel-text.png": "990b",
	"./carousel.png": "20c9",
	"./circle-card.png": "bedd",
	"./gold-card.png": "2a5b",
	"./horizontal-banner.png": "c9d5",
	"./paragraph.png": "fe9c",
	"./product-card.png": "7548",
	"./title.png": "45c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f06b";